"use client";
'use strict';

var React = require('react');

const ThemeContext = React.createContext({});

exports.ThemeContext = ThemeContext;
//# sourceMappingURL=Context.js.map
